<template>
  <span> {{ drivetrainJoin }} </span>
</template>

<script>
export default {
  name: "drivetrains",

  components: {},

  mixins: [],

  props: {
    drivetrains: {
      type: Array | null | undefined,
      default: () => [],
      description: "Drivetrains",
    },
  },

  data() {
    return {};
  },

  computed: {
    drivetrainsValue() {
      if (Array.isArray(this.drivetrains)) {
        return this.drivetrains.map((drivetrain) =>
          this.$t(`DRIVETRAIN.DRIVETRAIN_${drivetrain.toUpperCase()}`)
        );
      }

      return [];
    },

    drivetrainJoin() {
      return this.drivetrainsValue.join(", ");
    },
  },

  setup() {},

  created() {},

  methods: {},

  watch: {},
};
</script>
